var firebase = require('../firebaseAuth')
var to = require('await-to-js').default
/* Things to do for authentication: 
    1. If google email verification link expires before user verifies their email, then keep there information in the service for X period of time until they verify it
    2. If user doesnt verify within X time, then delete entry from service
    */
async function SignUpUser(userCredentials) {
    const confirmPassword = userCredentials.confirmPassword
    const password = userCredentials.password
    
    if (!password || !confirmPassword){
        //throw error here
        console.log("one or more user fields are missing.")
    }

    if(password !== confirmPassword){
        //throw error here
        console.log("passwords don't match.")

    }

    //add name, phone, email validation here
    let error, result;
    [error, result]  = await to(firebase.createUser(userCredentials))
  
    if (error){
        console.error("auth error", error.response)
        throw error
        //propogate error to higher level
    }

    return result
  
}

async function SignInUser(userCredentials) {
    const email = userCredentials.email
    const password = userCredentials.password
    const userCred = userCredentials

    
    if (!password || !email){
        //throw error here
    }
    let result, error;
    //add name, phone, email validation here
    [error, result] = await to(firebase.signIn(userCred))

    if (error){
        throw error
    }
    
    return result
    //.then((result) =>{
    //     console.log("result", result)
    //     return result

    // }).catch(error=>{
    //     //propogate error to higher level
    //     console.log("unable to login user", error)
    //     throw error
    // })

}

async function signOut(userCredentials){

}
async function getUser(userCredentials) {
    let UID = userCredentials.UID
    console.log("UID", UID)

    
    let result, error;
    //add name, phone, email validation here
    [error, result] = await to(firebase.getUser({UID}))

    if (error){
        console.log("redefinded", error.response)
        throw error
    }
    console.log("ufiudsafb result", result)

    return result
    //.then((result) =>{
    //     console.log("result", result)
    //     return result

    // }).catch(error=>{
    //     //propogate error to higher level
    //     console.log("unable to login user", error)
    //     throw error
    // })

}
async function passwordResetEmail(userCredentials) {
    let email = userCredentials.email


    
    let result, error;
    //add name, phone, email validation here
    [error, result] = await to(firebase.sendPasswordResetEmail({email}))

    if (error){
        console.log(error.response)
        throw error
    }
    console.log(result)

    return result
    //.then((result) =>{
    //     console.log("result", result)
    //     return result

    // }).catch(error=>{
    //     //propogate error to higher level
    //     console.log("unable to login user", error)
    //     throw error
    // })

}

async function VerifyEmail(userCredentials) {
    let UID = userCredentials.UID
    console.log("UID", UID)
    const userCred = {UID}

    
    let result, error;
    //add name, phone, email validation here
    [error, result] = await to(firebase.sendVerificationEmail({UID}))

    if (error){
        console.log(error.response)
        throw error
    }
    console.log(result)

    return result
    //.then((result) =>{
    //     console.log("result", result)
    //     return result

    // }).catch(error=>{
    //     //propogate error to higher level
    //     console.log("unable to login user", error)
    //     throw error
    // })

}

async function removeUser(userCredentials) {
    let UID = userCredentials.UID
    console.log("UID", UID)
    const userCred = {UID}

    
    let result, error;
    [error, result] = await to(firebase.deleteAccount({UID}))

    if (error){
        console.log(error.response)
        throw error
    }
    console.log(result)

    return result
    //.then((result) =>{
    //     console.log("result", result)
    //     return result

    // }).catch(error=>{
    //     //propogate error to higher level
    //     console.log("unable to login user", error)
    //     throw error
    // })

}

module.exports = {SignUpUser, SignInUser, getUser, VerifyEmail, removeUser, passwordResetEmail}


// WEBPACK FOOTER //
// ./src/services/Authentication/auth.js